import { InjectionToken } from '@angular/core';

import type { IPageSetupService } from './page-setup.models';

export const PageSetupService = new InjectionToken<IPageSetupService>('PageSetupService');
